__turbopack_context__.v({
  "refund-tooltip": "vv4g2W_refund-tooltip",
});
